import { render } from "./OverlayComp.vue?vue&type=template&id=2a3064a3"
import script from "./OverlayComp.vue?vue&type=script&lang=js"
export * from "./OverlayComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__